import store from "@/store";
import { QueryClient } from "@tanstack/vue-query";

export const setLoading = value => {
 store.dispatch("setIsLoading", value);
};

export const setMessage = (active, description, type) => {
 store.dispatch("setMessage", {
  active,
  description,
  type,
 });
};

export const handleApiResponse = async (request, defaultSuccessMessage) => {
 try {
  setLoading(true);
  const response = await request();

  const backendMessage = response.data?.message || null;
  const successMessage = backendMessage || defaultSuccessMessage;

  if (response.status === 200 && successMessage) {
   setMessage(true, successMessage, "success");
  }
  return response;
 } catch (error) {
  const errorMessage = error.response?.data?.message || error.response?.data || "An error occurred";
  setMessage(true, errorMessage, "error");
  throw error;
 } finally {
  setLoading(false);
 }
};

export const queryClient = new QueryClient({
 defaultOptions: {
  queries: {
   cacheTime: 1000 * 60 * 5, // 5 minutes
   //  staleTime: 60 * 1, // 1 minute
  },
 },
});
